import React from "react"
import PropTypes from "prop-types"
import * as css from "./Spacer.module.css"

const Spacer = ({
  children,
  direction,
  gap,
  justify,
  align,
  noWrap,
  className,
}) => {
  let classes = [className, css[gap]]
  classes.push(
    direction === "column" ? css.spacerVertical : css.spacerHorizontal
  )

  if (noWrap) {
    classes.push(css.spacerNoWrap)
  }

  if (align) {
    classes.push(css[`align_${align}`])
  }

  if (justify) {
    classes.push(css[`justify_${justify.replace("-", "_")}`])
  }

  return <div className={classes.join(" ")}>{children}</div>
}

Spacer.propTypes = {
  justify: PropTypes.oneOf([null, "center", "space-between"]),
  align: PropTypes.oneOf([null, "center"]),
  direction: PropTypes.oneOf(["column", "row"]),
  gap: PropTypes.oneOf(["none", "xsmall", "small", "medium", "large"]),
}

Spacer.defaultProps = {
  justify: null,
  align: null,
  direction: "column",
  gap: "medium",
  noWrap: false,
}

export { Spacer }
